var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('indica-form',{attrs:{"table-name":_vm.tableName,"id-to-edit":_vm.idToEdit,"edit-mode":false,"should-clear-form":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }